import React from "react";
import Image from "./image.js";

const Ad = () => {
  return (
    <aside>
      <a
        href="https://www.onemodel.app/"
        title="OneModel - A Diagramming Tool for Software Engineers"
         rel="noreferrer noopener"
        target="_blank">
        <h2>Diagramming?</h2>
        <p>Use these icons in OneModel today</p>
        <Image
          src="/onemodel.svg"
          alt="OneModel - Stop fighting your diagraming tool. Diagramming tailor-made for software engineers."
        />
        <div>
        <Image
          src="/ad.png"
          alt="OneModel - Stop fighting your diagraming tool. Diagramming tailor-made for software engineers."
        />
        </div>
      </a>
    </aside>
  );
};
export default Ad;
